import { observeElement } from '@uvocore-front/utils';
import Calculator from '@uvocore-front/calculator';
import getDefaultCalcOptions from './getDefaultCalcOptions';


const settings = {
  container: '[data-widget-calculator]',
  defaultConfigs: getDefaultCalcOptions(),
  layout: {
    name: 'big',
    version: 1,
    components: {
      OrderButton: {
        text: 'Place order',
      },
    },
  },
  theme: {
    typography: {
      baseFontFamily: '"PT Serif", sans-serif',
      baseFontSize: 16,
      baseBorderRadius: 0,
    },
    colors: {
      baseColor: '#000000',
      primaryColor: '#000000',
      borderColor: '#000000',
      spinnerRgbColor: '00 00 00',
    },
    components: {
      LayoutForm: {
        boxShadow: '0px 0px 0px 2px #000000 !important',
        borderRadius: 0,
      },
      LayoutComponentsWrapper: {
        label: {
          fontSize: 15,
          color: '#000000',
          fontStyle: 'italic',
        },
      },
      OrderServiceType: {
        borderBottomWidth: 0,
        button: {
          fontFamily: '"PT Serif", sans-serif',
          backgroundColor: '#000000',
          fontSize: '17px !important',
          color: '#ffffff',
          fontWeight: 600,
          letterSpacing: '0',
          borderRadius: 0,
          zIndex: 0,
          transition: 'background-color 0.3s ease, color 0.3s ease',
          '& svg path': {
            stroke: '#fff !important',
            transition: 'stroke 0.3s ease',
          },
          active: {
            color: '#000000',
            backgroundColor: 'white',
            boxShadow: 'none',
            zIndex: 1,
            opacity: 1,
            '& svg path': {
              stroke: '#000 !important',
            },
          },
          hover: {
            color: '#fff',
            backgroundColor: '#000000',
            'svg path': {
              stroke: '#fff !important',
            },
          },
          desktop: {
            fontSize: 16,
          },
        },
      },
      TaskSize: {
        '> div': {
          border: '2px solid #000000',
        },
        button: {
          fontFamily: '"PT Serif", sans-serif',
          fontSize: 14,
          border: 'none',
          borderRadius: 0,
          color: '#000',
          fontStyle: 'italic',
          '@media(min-width: 768px)': {
            fontSize: 16,
          },
          '&.UIButton--active': {
            color: '#ffffff',
          },
        },
      },
      UIButton: {
        transition: 'background-color 0.3s ease, color 0.3s ease',
        color: '#212123',
        borderRadius: 0,
        desktop: {
          fontSize: 16,
          lineHeight: '20px',
        },
        active: {
          color: '#fff',
        },
        hover: {
          backgroundColor: '#000000',
          color: '#fff',
        },
      },
      UISelect: {
        color: '#000000',
        '&::after': {
          desktop: {
            borderWidth: '8px 6px 0px',
            right: 15,
          },
        },
        select: {
          borderColor: '#000000',
          borderWidth: '2px',
          fontSize: 16,
          paddingLeft: '17px !important',
          ':hover': {
            borderWidth: 4,
            borderColor: '#000000',
          },
          lineHeight: '20px',
          desktop: {
            lineHeight: '20px',
            color: '#212123',
            paddingRight: 30,
          },
        },
      },
      OrderButton: {
        backgroundColor: '#000000',
        color: '#fff',
        fontSize: 17,
        padding: '12px 40px',
        borderRadius: 0,
        letterSpacing: 0,
        lineHeight: '1.45',
        textTransform: 'uppercase',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        textAlign: 'center',
        '@media(max-width: 1024px)': {
          width: '100%',
        },
        hover: {
          backgroundColor: '#000000',
          color: '#fff',
          textDecoration: 'none',
        },
      },
      Deadlines: {
        buttons: {
          '@media (min-width: 1140px)': {
            gridColumnGap: 0,
          },
        },
        button: {
          fontFamily: '"PT Serif", sans-serif',
          boxShadow: 'rgb(0 0 0) 0px 0px 0px 2px inset',
          transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
          hover: {
            boxShadow: 'inset 0px 0px 0px 4px #000000',
          },
          active: {
            boxShadow: 'inset 0px 0px 0px 4px #000000',
            span: {
              boxShadow: 'white 0px 0px 0px 4px, rgb(0 0 0) 0px 0px 0px 6px',
              backgroundColor: '#000 !important',
            },
          },
        },
        bigDeadlineButton: {
          strong: {
            desktop: {
              fontSize: 26,
              '::after': {
                color: '#000000 !important',
                fontSize: '16px !important',
              },
            },
          },
          div: {
            minHeight: 38,
            color: '#000000',
            fontSize: 16,
          },
        },
        deadlineMobileTrigger: {
          boxShadow: 'rgb(0 0 0) 0px 0px 0px 2px inset',
        },
      },
      DeadlineInfo: {
        color: '#000000',
        '@media(min-width: 768px)': {
          marginTop: 20,
          lineHeight: '24px',
        },
        strong: {
          color: '#000000',
          display: 'block',
        },
      },
      TaskSizeInfo: {
        backgroundColor: '#fff',
        boxShadow: 'none',
        zIndex: 1,
        border: '2px solid #000 !important',
        label: {
          letterSpacing: '1px',
          fontStyle: 'italic',
          fontSize: 12,
          fontWeight: 600,
          color: '#000000',
        },
        example: {
          border: 'none',
          borderRadius: '0',
          color: '#000000',
          fontSize: 16,
          '@media(min-width: 768px)': {
            fontSize: 14,
          },
          '@media(min-width: 1024px)': {
            border: '2px solid #000000',
          },
          strong: {
            fontSize: 16,
            color: '#000000',
            fontStyle: 'normal',
          },
        },
        Deliverables: {
          div: {
            fontSize: 15,
            color: '#000000',
            'svg path': {
              fill: '#000000',
            },
          },
          strong: {
            fontSize: 16,
            color: '#1c0e0d',
          },
        },
      },
      TotalPrice: {
        color: '#000000',
        marginTop: 0,
        '@media(min-width: 768px)': {
          marginTop: 16,
        },
        approximatePrice: {
          fontSize: '18px !important',
          fontWeight: 700,
          strong: {
            fontSize: 30,
            '@media (min-width: 768px)': {
              fontSize: 34,
            },
          },
        },
      },
    },
  },
};

observeElement({
  element: '[data-widget-calculator]',
  marginValue: 300,
  callback: () => {
    Calculator.init(settings);
  },
});
